export default [
  { countryName: 'All Countries', countryCode: 'All' },
  { countryName: 'USA', countryCode: 'USA' },
  { countryName: 'Canada', countryCode: 'CAN' },
  { countryName: 'Great Britain', countryCode: 'GBR' },
  { countryName: 'Germany', countryCode: 'DEU' },
  { countryName: 'South Africa', countryCode: 'ZAF' },
  { countryName: 'Norway', countryCode: 'NOR' },
  { countryName: 'Australia', countryCode: 'AUS' },
  { countryName: 'India', countryCode: 'IND' },
  { countryName: 'China', countryCode: 'CHN' },
  { countryName: 'Hong Kong', countryCode: 'HKG' },
  { countryName: 'Japan', countryCode: 'JPN' },
  { countryName: 'South Korea', countryCode: 'KOR' },
  { countryName: 'Malaysia', countryCode: 'MYS' },
  { countryName: 'Thailand', countryCode: 'THA' },
  { countryName: 'Singapore', countryCode: 'SGP' },
  { countryName: 'Taiwan', countryCode: 'TWN' },
  { countryName: 'Macau', countryCode: 'MAC' },
  { countryName: 'Singapore', countryCode: 'SGP' },
  { countryName: 'New Zealand', countryCode: 'NZL' },
  { countryName: 'Philippines', countryCode: 'PHL' },
  { countryName: 'Indonesia', countryCode: 'IDN' },
  { countryName: 'Vietnam', countryCode: 'VNM' },
  { countryName: 'Cambodia', countryCode: 'KHM' },
  { countryName: 'Laos', countryCode: 'LAO' },
  { countryName: 'Myanmar', countryCode: 'MMR' },
  { countryName: 'Bangladesh', countryCode: 'BGD' },
  { countryName: 'Pakistan', countryCode: 'PAK' },
  { countryName: 'Sri Lanka', countryCode: 'LKA' },
];
